import {
  CarType,
  CarModel,
  InfoDetailWrapper,
  CarAlernativeModelText,
} from '../CarRentalCard.styled';

interface IInfoDetail {
  type: string;
  modelName: string;
  alternativeModelName: string;
  vehicleCount: number;
  activeIndex: number;
}

const InfoDetail = ({
  type,
  modelName,
  alternativeModelName,
  vehicleCount,
  activeIndex,
}: IInfoDetail) => {
  return (
    <InfoDetailWrapper>
      <CarType>{type}</CarType>
      <CarModel>{modelName}</CarModel>
      {vehicleCount > 1 ? (
        <CarAlernativeModelText>
          <span>ya da</span> <b>MUADİLLERİ</b>
          <span>{activeIndex === 0 ? '' : ' | '}</span>
          <b>{alternativeModelName}</b>
        </CarAlernativeModelText>
      ) : null}
    </InfoDetailWrapper>
  );
};

export default InfoDetail;
